import { useSuspenseInfiniteQuery, UseSuspenseInfiniteQueryOptions, QueryFunctionContext, InfiniteData, QueryKey } from '@tanstack/react-query';

export const useApiSuspenseInfiniteQuery = <
  TQueryFnData = unknown,
  TError = unknown,
  TData = InfiniteData<TQueryFnData>,
>({
  queryKey,
  queryFn,
  getNextPageParam,
  initialPageParam = 1,
  ...options
}: {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<TQueryFnData>;
  getNextPageParam: (lastPage: TQueryFnData, allPages: TQueryFnData[]) => any | undefined;
  initialPageParam?: any;
} & Omit<UseSuspenseInfiniteQueryOptions<TQueryFnData, TError, TData>, 'queryKey' | 'queryFn' | 'getNextPageParam' | 'initialPageParam'>) => {
  return useSuspenseInfiniteQuery({
    queryKey,
    queryFn,
    getNextPageParam,
    initialPageParam,
    retry: 2,
    staleTime: 5 * 60 * 1000,
    ...options,
  });
};